export const TrainingNewAzureSearchTypesConstants = {
    TRAINING_NEW_AZURE_SEARCH: "TRAINING_NEW_AZURE_SEARCH",
    TRAINING_NEW_LAST_SEARCH: "TRAINING_NEW_LAST_SEARCH"
}